<template>
	<footer class="app-footer">
		<btn-edit
			v-if="editable"
			:top="10"
			@edit-section="goToCompany"
		/>
		<div class="app-wrapper app-footer-links">
			<div class="app-footer-col">
				<h3 class="app-footer-title">Nuestra Marca</h3>
				<div class="app-footer-row">
					<ul class="app-footer-list">
						<li><a href="#"
						@click.prevent="transitionUs">Nosotros</a></li>
						<li><router-link to="/productos">Productos</router-link></li>
						<li><a href="#router"
							@click.prevent="transitionHistory">Historia</a></li>
					</ul>
				</div>
			</div>
			<div class="app-footer-col">
				<h3 class="app-footer-title">Aris Industrial</h3>
				<div class="app-footer-row">
					<ul class="app-footer-list">
						<li
							v-for="(link, index) in company.relatedLinks[0]"
							:key="`link-1-${index}`">
							<a target="_blank" :alt="link.text" :href="link.url">{{link.text}}</a></li>
					</ul>
					<ul class="app-footer-list">
						<li
							v-for="(link, index) in company.relatedLinks[1]"
							:key="`link-2-${index}`">
							<a target="_blank" :alt="link.text" :href="link.url">{{link.text}}</a></li>
					</ul>
				</div>
			</div>
			<div class="app-footer-col">
				<h3 class="app-footer-title">Contáctanos</h3>
				<div class="app-footer-row">
					<ul class="app-footer-list">
						<li>
							<a :href="`tel:${companyData.numberContact}`" class="app-footer-list-item">
								<img src="/static/img/icons/phone-footer-home.svg" alt="image-phone-footer" class="item-icon"> 
								{{ companyData.numberContact }}
							</a>
						</li>
						<li>
							<a :href="`mailto:${companyData.mailContact}`" class="app-footer-list-item">
								<img src="/static/img/icons/home-footer-mail.svg" alt="image-mail-footer" class="item-icon">
								{{ companyData.mailContact }}
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="app-footer-col">
				<div class="app-footer-row">
					<ul class="app-footer-list">
						<li v-if="false && companyData.logoMaster && companyData.logoMaster[0]">
							<a href="/">
								<img
									:src="companyData.logoMaster[0].url"
									:alt="companyData.logoMaster[0].title"
									class="app-footer-logo-aquapool"
									height="108px"
									width="95px"
								/>
							</a>
						</li>
						<li v-if="companyData.logoCompany && companyData.logoCompany[0]">
							<a href="/">
								<img
									:src="companyData.logoCompany[0].url"
									:alt="companyData.logoCompany[0].title"
									class="app-footer-logo-aris"
								/>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="app-wrapper app-footer-social" v-if="false">
			<template v-for="(media, index) in companyData.socialMedia">
				<a
					:key="index"
					:href="media.link"
					class="social-icon">
					<simple-svg 
						class="social-icon"
						:filepath="media.icon"
						:height="'30px'"
						:fill="'#fff'"
					/>
				</a>
			</template>
		</div>
		<div class="app-footer-social">
			<div class="app-wrapper">
				<div class="app-footer-social-copyright">
					<div>
						<a
							target="_blank"
							download="/static/files/política-de-privacidad.pdf"
							href="/static/files/política-de-privacidad.pdf">Políticas de privacidad</a>
					</div>
					<div>
						<p>Copyright © 2019 Aris</p>
					</div>
				</div>
				<div class="app-footer-social-links">
					<template v-for="(media, index) in companyData.socialMedia">
						<a
							:key="index"
							:href="media.link"
							class="social-icon">
							<simple-svg 
								class="social-icon"
								:filepath="media.icon"
								:height="'30px'"
								:fill="'#fff'"
							/>
						</a>
					</template>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import orderBy from 'lodash/orderBy';
import btnEdit from '@/components/commons/btn-edit';

const computed = {
	company() {
		const { company } = this.$store.state;
		const links = orderBy(company.linkUrl, 'order');
		company.relatedLinks = [
			[
				...links.filter((l, i) => i < links.length / 2),
			],
			[
				...links.filter((l, i) => links.length / 2 <= i && i < links.length),
			],
		];
		return company;
	},
};

function transitionUs() {
	this.$router.push({ name: 'page-home' });
	setTimeout(() => {
		this.scrollTo('transition-us', 1000, false);
	},
	1000);
}

function transitionHistory() {
	this.$router.push({ name: 'page-home' });
	setTimeout(() => {
		this.scrollTo('transition-history', 1000, false);
	},
	1000);
}

function goToCompany() {
	this.goTo('page-admin-company');
}

function data() {
	return {
		coords: {
			lat: -12.0398200,
			lng: -77.0745303,
		},
	};
}

export default {
	name: 'app-footer',
	computed,
	data,
	methods: {
		transitionHistory,
		transitionUs,
		goToCompany,
	},
	props: {
		companyData: {
			default: () => {},
			type: Object,
		},
	},
	components: {
		btnEdit,
	},
};
</script>

<style lang="scss" scoped>


	.app-footer-social {
		background-color: #001d32;
		padding: 25px;
		margin-bottom: -60px;

		.app-wrapper {
			@include display-flex();
			align-items: center;
			justify-content: space-between;
		}

		&-copyright {
			color: white;

			a {
				@include font-size(12);
			}
		}

		&-links {
			@include display-flex();
		}	
	}

	.app-footer-social-item {
		@include display-flex();
		@include border-radius(50%);
		align-items: center;
		background-color: white;
		height: 42px;
		justify-content: center;
		margin-right: 20px;
		padding: 10px;
		width: 42px;

		&:last-child {
			margin-right: 0;
		}

		.item-icon {
			display: inherit;
			max-height: 30px;
			width: auto;
		}
	}

	.is-mobile {
		display: none;
	}

.app-footer {
	background-image: url("/static/img/background-footer.jpg");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	color: map-get($colors, white);
	padding: 90px 0 60px;
	position: relative;
}

.app-footer-links {
	@include display-flex();
	justify-content: space-between;
	margin-bottom: 80px;
}

.app-footer-row {
	@include display-flex();
	justify-content: space-between;

	.app-footer-list + .app-footer-list {
		margin-left: 25px;
	}
}

.app-footer-title {
	@include font-size(20);
	@include font-maison-bold();
	margin-bottom: 10px;
}

.app-footer-list {
	@include font-size(14);
	@include font-maison-light();
	line-height: 1.6;
}

.app-footer-list-item {
	display: block;
	margin-top: 10px;
}

.item-icon {
	display: inline-block;
	margin-right: 10px;
	vertical-align: text-top;
}

.app-footer-logo-aquapool {
	max-width: 184px;
}

.app-footer-logo-aris {
	max-width: 140px;
}

@media (min-width: 601px) and (max-width: 1024px) {
	.app-footer {
		padding: 40px 0;
	}

	.app-footer-links {
		flex-wrap: wrap;
	}

	.app-footer-col {
		margin-bottom: 30px;
		width: 40%;
	}
}

@media screen and (max-width: 600px) {
	.app-footer {
		padding: 40px 0;
	}

	.app-footer-links {
		flex-direction: column;
		margin-bottom: 30px;
	}

	.app-footer-row {
		justify-content: flex-start;
	}

	.app-footer-col {
		margin-bottom: 30px;

		.app-footer-list {
			width: 100%;
		}

		&:last-child {
			margin-top: 40px;
			text-align: center;
		}
	}

	.app-footer-social {
		width: 100%;
		
		.social-icon {
			margin: 0 3%;
		}
	}
}

@media screen and (max-width: 600px) {
	.app-footer-social {
		width: 100%;

		.social-icon {
			margin: 0 3%;
			
			&.mobile {
				display: inline-block;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/commons/app-footer.vue